<p-toast></p-toast>
<div class="ui grid">
  <div class="column">
    <div class="ui basic segment">
      <form class="ui form" [formGroup]="userSupportForm">
        <h4 class="ui header form-title">
          is something giving you trouble: tell us!
        </h4>
        <div class="field">
          <div class="two fields">
            <div class="field">
              <label>Full Name</label>
              <input type="text" formControlName="name" />
              <div
                class="ui pointing red basic label middle aligned"
                *ngIf="
                  userSupportForm.get('name').errors &&
                  (userSupportForm.get('name').touched ||
                    userSupportForm.get('name').dirty)
                "
              >
                Required!
              </div>
            </div>
            <div class="field">
              <label>Email</label>
              <input type="text" formControlName="email" />
              <div
                class="ui pointing red basic label middle aligned"
                *ngIf="
                  userSupportForm.get('email').errors &&
                  (userSupportForm.get('email').touched ||
                    userSupportForm.get('email').dirty)
                "
              >
                Required!
              </div>
            </div>
          </div>
          <div class="two fields">
            <div class="field">
              <label>Catagory</label>
              <div class="ui selection dropdown" fuiDropdown>
                <input
                  type="hidden"
                  name="category"
                  formControlName="category"
                />
                <i class="dropdown icon"></i>
                <div class="text">{{ selectedCategory || 'Category' }}</div>
                <div class="menu" fuiDropdownMenu>
                  <div
                    class="item"
                    *ngFor="let category of categories"
                    (click)="selectedCategoryOption(category)"
                  >
                    {{ category }}
                  </div>
                </div>
              </div>
            </div>
            <div class="field">
              <label>City</label>
              <input type="text" />
            </div>
          </div>
          <div class="two fields">
            <div class="field">
              <label>Subject</label>
              <input type="text" formControlName="subject" />
              <div
                class="ui pointing red basic label middle aligned"
                *ngIf="
                  userSupportForm.get('subject').errors &&
                  (userSupportForm.get('subject').touched ||
                    userSupportForm.get('subject').dirty)
                "
              >
                Required!
              </div>
            </div>
            <div class="field">
              <ng-template let-option #optionTemplate>
                <i class="{{ option.countryCode }} flag"></i>
                {{ option.name }}
              </ng-template>
              <label>Country</label>
              <ng-select
                [items]="country"
                bindLabel="name"
                [(ngModel)]="countryCode"
                [ngModelOptions]="{ standalone: true }"
                (keyup)="onCountrySearchByName($event)"
              >
              </ng-select>
            </div>
          </div>
          <div class="two fields">
            <div class="field">
              <label>Priority</label>
              <div class="ui selection dropdown" fuiDropdown>
                <input
                  type="hidden"
                  name="priority"
                  formControlName="priority"
                />
                <i class="dropdown icon"></i>
                <div class="text">{{ selectedPriority || 'Priority' }}</div>
                <div class="menu" fuiDropdownMenu>
                  <div
                    class="item"
                    *ngFor="let priority of priority"
                    (click)="selectedPriorityOption(priority)"
                  >
                    {{ priority }}
                  </div>
                </div>
              </div>
            </div>
            <div class="field">
              <label>Description</label>
              <textarea formControlName="description"></textarea>
              <div
                class="ui top pointing red basic label"
                *ngIf="
                  userSupportForm.get('description').errors &&
                  (userSupportForm.get('description').touched ||
                    userSupportForm.get('description').dirty)
                "
              >
                Required!
              </div>
            </div>
          </div>
        </div>

        <div class="submit-block">
          <button
            class="ui small {{ buttonColor }} button"
            (click)="userSupportData()"
            [disabled]="!userSupportForm.valid"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
